import { ITeacherSchedule } from '~/types/teacher-schedule'
import http from '~/utils/http'

/** 获取老师排班 */
export function getTeacherSchedule(page: number, size: number) {
  return http.get('/admin/teacher/schedule', {
    params: {
      page,
      size,
    },
  })
}

/** 新增老师排班 */
export function postTeacherSchedule(data: Partial<ITeacherSchedule>) {
  return http.post('/admin/teacher/schedule', data)
}

/** 删除老师排班 */
export function deleteTeacherSchedule(id: number) {
  return http.delete(`/admin/teacher/schedule/${id}`)
}

/** 编辑老师排班 */
export function patchTeacherSchedule(id: number, data: Partial<ITeacherSchedule>) {
  return http.patch(`/admin/teacher/schedule/${id}`, data)
}
